import React, { Component, lazy, Suspense } from 'react'
import Carousel from 'react-multi-carousel'
import { gql } from 'apollo-boost'
import { graphql, withApollo } from 'react-apollo'
import { Link, withRouter } from 'react-router-dom'

import { GA_ACTION, GA_EVENT } from '../analytics'

import 'react-multi-carousel/lib/styles.css'
import './LandingPage.css'

import forbes from '../images/forbes_grey.webp'
import hollywoodReporter from '../images/hollywood_grey.webp'
import pureWow from '../images/purewow_grey.webp'
import videoIcon from '../images/video_icon.webp'

import image1 from '../images/landing page/image_1.webp'
import image2 from '../images/landing page/image_2.webp'
import image3 from '../images/landing page/image_3.webp'
import image4 from '../images/landing page/image_4.webp'


const WistiaVideo = lazy(() => import ('./WistiaVideo'))

class LandingPage extends Component {

  render() {

    return (
      <div className="landing-page">
        <div className="static-page">
          <div className="wrapper">
            <div className="top-flex">

              <div className="title-section">
                <h1>Introducing Theatre Roulette</h1>
                <div className="header-description title-description">You pick the day,<br className="hidedesktop"/> we pick the show!</div>
              </div>

              <div className="collage hidemobile">
                <div className="content-container flex-row top">
                  <div className="image-stack">
                    <div className="image-stack__item image-container-1">
                      <div className="theater-image-1 image" />
                    </div>
                    <div className="image-stack__item image-container-2">
                      <div className="theater-image-2 image" />
                    </div>
                    <div className="image-stack__item image-container-4">
                      <div className="theater-image-4 image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="image-stack-mobile hidedesktop">
              <div class="image-stack__item image-container-1">
                <div className="theater-image-1 image" />
              </div>
              <div class="image-stack__item image-container-4">
                <div className="theater-image-4 image" />
              </div>
              <div class="image-stack__item image-container-2">
                <div className="theater-image-2 image" />
              </div>
            </div>

            <div className="logos">
              <div className="logos-text">As seen in:</div>
              <div className="logos-flex">
                <a target="_blank" rel="noopener noreferrer" href="https://www.forbes.com/sites/jerylbrunner/2019/09/03/how-one-entrepreneur-doubles-her-revenues-each-year-and-continues-to-stay-innovative/?sh=46cf614242f3">
                  <img src={forbes}className="company-logo" alt="Forbes" width="300px" height="83" />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.hollywoodreporter.com/news/broadway-roulette-lets-theatergoers-gamble-tickets-1129381">
                  <img src={hollywoodReporter} className="company-logo hollywood" alt="Hollywood Reporter" width="300px" height="78" />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.purewow.com/entertainment/broadway-roulette-nyc">
                  <img src={pureWow} className="company-logo" alt="Pure Wow" width="300px" height="102" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="playbill-photos">
          <div className="playbill-menu">
            <Carousel additionalTransfrom={0}
                      arrows
                      autoPlaySpeed={3000}
                      centerMode={false}
                      className="carousel"
                      containerClass="container-with-dots"
                      dotListClass=""
                      draggable
                      focusOnSelect={false}
                      infinite
                      itemClass=""
                      keyBoardControl
                      minimumTouchDrag={80}
                      renderButtonGroupOutside={true}
                      responsive={{
                        desktop: {
                          breakpoint: {
                            max: 4000,
                            min: 1200
                          },
                          items: 3,
                          partialVisibilityGutter: 0
                        },
                        mobile: {
                          breakpoint: {
                            max: 600,
                            min: 0
                          },
                          items: 1,
                          partialVisibilityGutter: 30
                        },
                        tablet: {
                          breakpoint: {
                            max: 1200,
                            min: 600
                          },
                          items: 2,
                          partialVisibilityGutter: 30
                        }
                      }}
              showDots={false}
              sliderClass=""
              slidesToSlide={1}
              swipeable
            >

              <div id="image-1">
                <img src={image1} alt="Program photos" height="400px" width="400px" />
              </div>

              <div id="image-2">
                <img src={image2} alt="Hamilton Marquee" height="400px" width="400px" />
              </div>

              <div id="image-3">
                <img src={image3} alt="Hamilton" height="400px" width="400px" />
              </div>

              <div id="image-4">
                <img src={image4} alt="Tina" height="400px" width="400px" />
              </div>

            </Carousel>
          </div>
        </div>
      </div>
    )
  }
}

export const USER_QUERY = gql`
  query UserQuery {
    user {
      id

      orders {
        items {
          id
          isValidOrder
          requestedShowDate

          orderStatus {
            sentTicketsEmailAt
          }
        }
      }
    }
  }
`

export default withRouter(withApollo(graphql(USER_QUERY, {
  name: 'userQuery',
  options: (ownProps) => {
    return {
      variables: {}
    }
  }
})(LandingPage)))
